// src/components/pages/Produto/tabs/CabecalhoTabPanel.jsx
import React from 'react';

import formStyles from '../../../form/Form.module.css';

// componentes do seu projeto (ajuste paths conforme seu projeto)
import Select from '../../../form/Select';
import Input from '../../../form/Input';
import InputNumber from '../../../form/InputNumber';
import Checkbox from '../../../form/Checkbox';

/* utils */
import { formatarNumero, formatarNumero3Digitos } from '../../../../utils/masks';
/**
 * Painel fr caracteristicas do Produto
 * - Burro: só renderiza
 * - Toda lógica fica no Form/useModule
 */
const CaracteristicasTabPanel = ({
    module,

    //parametros
    profile,
    //options e enums
    OptionsAlmoxarifados,
}) => {
    const { dados } = module.state;
    const { change: onChange, focus: onFocus, blur: onBlur } = module.actions;
    const uiTab = profile.uiTabs.caracteristicas;

    return (
        <div>
            <div className={formStyles.preview_bandeira}>
                <h4>{uiTab?.labels?.grid}</h4>
            </div>
            <Checkbox
                title="Informa que o produto é pesável e não possui características distintas"
                text="Pesável"
                name="pesavel"
                handleOnChange={onChange}
                value={dados.pesavel}
                checked={!!dados.pesavel}
            />
            <InputNumber
                text="Peso Bruto"
                type="text"
                name="pesoBruto"
                placeholder="peso em Kg"
                inputWidth="100px"
                title="digite o peso bruto do produto em Kg"
                handleOnChange={onChange}
                handleOnFocus={onFocus}
                handleOnBlur={onBlur}
                value={dados.pesoBruto ? formatarNumero3Digitos(dados.pesoBruto) : ''}
            />
            <InputNumber
                text="Peso Líquido"
                type="text"
                name="pesoLiquido"
                placeholder="peso em kg"
                inputWidth="100px"
                title="digite o peso líquido do produto em Kg"
                handleOnChange={onChange}
                handleOnFocus={onFocus}
                handleOnBlur={onBlur}
                value={dados.pesoLiquido ? formatarNumero3Digitos(dados.pesoLiquido) : ''}
            />
            <InputNumber
                text="Estoque Mínimo"
                type="text"
                name="estoqueMinimo"
                placeholder="Estoque mínimo operacional"
                inputWidth="100px"
                title="digite o valor do estoque mínimo do produto"
                handleOnChange={onChange}
                handleOnFocus={onFocus}
                handleOnBlur={onBlur}
                value={dados.estoqueMinimo ? formatarNumero(dados.estoqueMinimo) : ''}
            />

            <InputNumber
                text="Largura"
                type="text"
                name="largura"
                placeholder=""
                inputWidth="100px"
                title="digite a largura em metros"
                handleOnChange={onChange}
                handleOnFocus={onFocus}
                handleOnBlur={onBlur}
                value={dados.largura ? formatarNumero3Digitos(dados.largura) : ''}
            />
            <InputNumber
                text="Altura"
                type="text"
                name="altura"
                placeholder=""
                inputWidth="100px"
                title="digite a altura em metros"
                handleOnChange={onChange}
                handleOnFocus={onFocus}
                handleOnBlur={onBlur}
                value={dados.altura ? formatarNumero3Digitos(dados.altura) : ''}
            />
            <InputNumber
                text="Comprimento"
                type="text"
                name="comprimento"
                placeholder=""
                inputWidth="100px"
                title="digite a comprimento em metros"
                handleOnChange={onChange}
                handleOnFocus={onFocus}
                handleOnBlur={onBlur}
                value={dados.comprimento ? formatarNumero3Digitos(dados.comprimento) : ''}
            />
            <InputNumber
                text="Volume m³"
                type="text"
                name="volume"
                placeholder="m³"
                inputWidth="100px"
                title="volume em metros cúbicos m³"
                handleOnChange={onChange}
                handleOnFocus={onFocus}
                handleOnBlur={onBlur}
                value={dados.volume ? dados.volume : ''}
                readonly={true}
            />

            <div>
                <Select
                    name="almoxarifadoId"
                    title="Almoxarifado padrão para o produto"
                    text="Almoxarifado"
                    inputWidth="200px"
                    options={OptionsAlmoxarifados}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.almoxarifadoId}
                    isEnum={false}
                    notOptNull={false}
                />
                <InputNumber
                    text="Comissão"
                    type="text"
                    name="comissao"
                    placeholder="Comissão do produto no movimento"
                    inputWidth="100px"
                    title="digite o valor do comissão do produto"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.comissao ? formatarNumero(dados.comissao) : ''}
                />
            </div>
        </div>
    );
};

export default React.memo(CaracteristicasTabPanel);
